module.exports = __webpack_public_path__ + "static/media/2020.8.10学习《习近平谈治国理政》第三卷.a5add825.jpg";